'use client';
import parse from 'html-react-parser';

export default function Table(Prop: {moduleOption: any}) {
  const options = Prop.moduleOption || {};
  const templateItems = options?.items ?? [];
  const formTemplate = (templateItem: any) => {
    let template = options?.template ?? '';
    const regex = /\{([A-Za-z]+(?:.[A-Za-z]+)*)\}/g;
    const matches = template.matchAll(regex);
    for (const match of Array.from(matches) as RegExpMatchArray[]) {
      const key = match[1];
      // get data with dot path
      let data = templateItem;
      key.split('.').forEach((k) => {
        data = data[k.trim()];
      });
      template = template.replaceAll(`{${key}}`, data);
    }
    return parse(template);
  };

  const formTemplateRaw = (templateItem: any) => {
    let template = options?.template ?? '';
    Object.entries(templateItem).forEach(([key, value]) => {
      template = template.replaceAll(`{${key}}`, value);
    });
    return template;
  };

  return (
    <table className={options?.class}>
      <thead className={options?.theadclass}>
        <tr>
          {(options?.headers ?? '').split(',').map((h: any, i: number) => (
            <th key={'th-' + i} dangerouslySetInnerHTML={{__html: h}}></th>
          ))}
        </tr>
      </thead>
      <tbody className={options?.tbodyclass}>
        {templateItems.map((templateItem: any, index: number) => (
          <tr
            key={index}
            className={options?.itemclass || options?.subclass}
            dangerouslySetInnerHTML={{__html: formTemplateRaw(templateItem)}}
          ></tr>
        ))}
      </tbody>
    </table>
  );
}
